/* Fur Felons product page motion: photo "develops" on arrival + on color change; GUILTY stamp on add to cart. */
(function () {
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var timer;
  function develop() {
    if (RM) return;
    var galleries = document.querySelectorAll('.product-information media-gallery');
    galleries.forEach(function (g) {
      g.classList.remove('ff-develop');
      void g.offsetWidth; // restart the animation
      g.classList.add('ff-develop');
    });
    clearTimeout(timer);
    timer = setTimeout(function () { galleries.forEach(function (g) { g.classList.remove('ff-develop'); }); }, 1700);
  }
  function stamp() {
    if (RM) return;
    var s = document.createElement('div');
    s.className = 'ff-stamp';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = 'GUILTY';
    document.body.appendChild(s);
    setTimeout(function () { s.remove(); }, 1900);
  }
  function snapToPhoto() {
    var g = document.querySelector('.product-information media-gallery');
    if (!g || window.innerWidth >= 750) return;
    var r = g.getBoundingClientRect();
    var header = document.querySelector('header, .header, header-component');
    var offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    // Only scroll when the photo's top is out of view (typical on phones after scrolling down to the swatches).
    if (r.top < offset - 4 || r.top > window.innerHeight * 0.6) {
      window.scrollTo({ top: window.scrollY + r.top - offset - 8, behavior: RM ? 'auto' : 'smooth' });
    }
  }
  var lastColor = null;
  function colorNow() {
    var el = document.querySelector('.product-information .variant-option--swatches input:checked');
    return el ? el.value : null;
  }
  document.addEventListener('shopify:product:select', function () {
    setTimeout(function () {
      var c = colorNow();
      if (c && c !== lastColor) { lastColor = c; develop(); snapToPhoto(); }
    }, 60);
  }, true);
  var addClickedAt = 0;
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.add-to-cart-button, .sticky-add-to-cart button[type="submit"]')) addClickedAt = Date.now();
  }, true);
  document.addEventListener('shopify:cart:lines-update', function () {
    if (Date.now() - addClickedAt < 8000) { addClickedAt = 0; stamp(); }
  }, true);
  function start() { lastColor = colorNow(); develop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
